import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiModal } from '@jtnews/jtn-ui';
import { tsStoreMixin } from '@jtnews/shared';
import { NoServerRendering } from '@jtnews/shared/no-ssr';

import { BlockedUserForm } from '../../blocked-user-form';

type ModalEvents = {
  onChangeModalState: (isOpen: boolean) => void;
};

const DESKTOP_MODAL_WIDTH = 620;
const MOBILE_MODAL_WIDTH = 320;
const MODAL_ID = 'blocked_user_modal';

export default componentFactoryOf<ModalEvents>()
  .mixin(tsStoreMixin)
  .create({
    name: 'BlockedUserModal',
    model: {
      prop: 'isOpen',
      event: 'changeModalState'
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      maxWidth(): number {
        return this.store.deviceInfo.isMobile ? MOBILE_MODAL_WIDTH : DESKTOP_MODAL_WIDTH;
      }
    },
    methods: {
      changeModalState() {
        this.$emit('changeModalState', !this.isOpen);
      }
    },
    render() {
      return (
        <NoServerRendering>
          <JtnUiModal
            isOpen={this.isOpen}
            onToggle={() => this.changeModalState()}
            maxWidth={this.maxWidth}
            targetName={MODAL_ID}
            appendTo="body"
          >
            <BlockedUserForm onClosed={() => this.changeModalState()} />
          </JtnUiModal>
        </NoServerRendering>
      );
    }
  });
